import { Component, OnInit } from '@angular/core';
import { DateTimeService } from '@services/index';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  currentYear: number;
  constructor(private dateTimeService: DateTimeService) { }

  ngOnInit() {
    this.currentYear = this.dateTimeService.now().year();
  }

}
